import Checkbox from './Checkbox';

export default Checkbox;
export { CheckboxIndicator } from './Checkbox';
export type { ICheckboxProps } from './Checkbox';
